// productsData.js
const productsData = {
  bellow: [
    { id: 1, name: "Fabric Bellow ", price: "$499", image: "/images/bellow.png" },
    
      { id: 3, name: "Lamella Bellow ", price: "$499", image: "/images/lamella bellow.jpg" },
    { id: 4, name: "Scissor Lift Bellow ", price: "$499", image: "/images/scissor lift bellow.png" },
      { id: 5, name: "LM Rail Bellow ", price: "$499", image: "/images/lm rail bellow.jpg" },
    { id: 6, name: "Rack Bellow ", price: "$499", image: "/images/rack bellow.jpg" },
     { id: 7, name: "Scissor Bellow ", price: "$499", image: "/images/scissor bellow.jpg" },
    { id: 8, name: "Aluminium Coated Bellow ", price: "$499", image: "/images/aluminium coated bellow.webp" },
      { id: 9, name: "Nytral Coated Bellow ", price: "$499", image: "/images/nytral coated bellow.webp" },
   { id: 9, name: "Expansion joint  ", price: "$499", image: "/images/expansion joints.jpg" },
   { id: 9, name: "Rubber Expansion joint  ", price: "$499", image: "/images/rubber expansion joints.jpg" },
   
  ],
  conveyor: [
    
    { id: 4, name: "Flat Hinged Belt Conveyor ", price: "$199", image: "/images/flat hinged belt conveyor.webp" },
     { id: 3, name: "Modular Conveyor ", price: "$299", image: "/images/Modular Conveyor.jpg" },
    { id: 4, name: "Roller Conveyor ", price: "$199", image: "/images/roller conveyor.jpg" },
    { id: 3, name: "Inclined Conveyor ", price: "$299", image: "/images/inclined conveyor.jpg" },
    { id: 4, name: "Belt Conveyor ", price: "$199", image: "/images/Flat Belt Conveyor.jpg" },
    { id: 3, name: "Magnetic Conveyor  ", price: "$299", image: "/images/magnetic conveyor.jpg" },
    { id: 4, name: "Scrapper Conveyor  ", price: "$199", image: "/images/scrapper conveyor.jpg" },
    { id: 3, name: "Screw Conveyor  ", price: "$299", image: "/images/Screw Conveyor.jpg" },
    { id: 4, name: "Spiral Conveyor   ", price: "$199", image: "/images/Spiral Conveyor.jpg" },
  ],
  telescopiccover: [
    { id: 5, name: "Camping Tent", price: "$149", image: "https://picsum.photos/id/204/200" },
    { id: 6, name: "Hiking Backpack", price: "$89", image: "https://picsum.photos/id/205/200" },
  ],
};

export default productsData;
